var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"outlined":"","dense":"","items":_vm.artists,"item-value":"artistCode","label":"Artist","item-text":"name","return-object":""},on:{"change":function($event){return _vm.handleArtistChange()}},model:{value:(_vm.artist),callback:function ($$v) {_vm.artist=$$v},expression:"artist"}})
}
var staticRenderFns = []

export { render, staticRenderFns }